import React from 'react';
import { Input } from 'antd';
import { FormContext } from '../FormContext';

export default function TextInput({ inputId = null }) {
	const formContext = React.useContext(FormContext);
	const { rowOptions, formValuesById, setFormValuesById } = formContext;
	const { rowTypeData } = rowOptions;

	if (!inputId) {
		inputId = rowTypeData.inputId;
	}

	const onInputChange = e => {
		const { id, value } = e.target;
		setFormValuesById({
			...formValuesById,
			[id]: value,
		});
	};

	return (
		<Input
			id={inputId}
			value={formValuesById[inputId]}
			onChange={onInputChange}
		/>
	);
}
